import {
  SafeTag,
  PendingOffer,
  Alert,
  Button
} from '@itau-loans-www/components'
import IconAviso from '@mobi/ds/static/icons/outlined/aviso.svg'
import IconInovacao from '@mobi/ds/static/icons/outlined/inovacao.svg'

import Layout from '../../layouts/Summary'
import { usePhotoError } from './hooks'
import './photo-error.scss'

const PhotoError = () => {
  const {
    proposal,
    isLoading,
    closeAlert,
    isAlertVisible,
    handleGetNewOffer,
    handleSendProposalAsIs
  } = usePhotoError()

  return (
    <Layout>
      <div className="photo-error container">
        <SafeTag />
        <Alert
          isVisible={isAlertVisible}
          paragraph={null}
          icon={<IconAviso />}
          message={`
            <h2>
              Inconsistência
            </h2>
            <p>
              Foto tremida ou ilegível
            </p>
            `}
          closeAlert={closeAlert}
          variant="error"
        />
        <section className="photo-error__content">
          <h1 className="photo-error__content-title">
            Sua proposta ainda não foi formalizada
          </h1>
          <p className="photo-error__content-subtitle">
            Para dar continuidade, garanta que a foto do documento não saia
            tremida e que as informações estejam legíveis.
          </p>

          <div className="photo-error__content-tip">
            <div className="photo-error__content-tip-icon">
              <IconInovacao />
            </div>
            <ul className="photo-error__content-tip-text">
              <strong>Dicas:</strong>
              <br />
              <li>
                • &nbsp; A foto do documento de identidade precisa ser frente e
                verso;
              </li>
              <li>
                • &nbsp; Preste atenção para que seus olhos não apareçam
                fechados.
              </li>
            </ul>
          </div>

          <PendingOffer proposal={proposal} />

          <div className="photo-error__content-btn-wrapper">
            <Button
              variant="secondary"
              isLoading={isLoading}
              disabled={isLoading}
              id="#cross-sell"
              onClick={handleGetNewOffer}
            >
              Fazer nova simulação
            </Button>
            <Button
              id="#send-proposal"
              isLoading={isLoading}
              disabled={isLoading}
              onClick={handleSendProposalAsIs}
            >
              Formalizar minha proposta
            </Button>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default PhotoError
